<template>
  <div class="card">
    <div class="card-body" ref="searchBox">
      <div class="d-flex with-button">
        <div class="p-2">
          <h1>시험이력</h1>
        </div>
        <div class="p-2 small bottom">
          총 <strong><span class="number mint">{{tableTotal}}</span></strong> 건
        </div>
        <div class="ml-auto p-2">
          <excel :name="btnExcelName" @click="downloadExcel" :loading="excelLoading"></excel>
        </div>
      </div>

      <div class="d-flex">
        <div class="p-2 w-100">
          <div class="input-group search">
            <div class="input-group-prepend">
              <span class="input-group-text"><i class="fas fa-search"></i></span>
            </div>
            <input type="text" class="form-control" aria-describedby="basic-addon1" v-model.trim="search.search_text" @keyup.enter="retrieve" placeholder="시험명">
            <div class="input-group-apend">
              <button type="button" class="btn btn-default" @click="retrieve">
                 검색
              </button>
            </div>
          </div>
        </div>
        <div class="p-2 search-detail" v-if="searchDetailVisible">
          <a href="#" class="arrowdown"><i class="fas fa-angle-double-down"></i></a>
        </div>
      </div>
    </div>

    <stone-data-table
      :loading="searchLoading"
      :columns="tableColumns"
      :data="tableData"
      :table-props="tableProps"
      :page-size="emptyPageSize"
      :pagination-props="emptyPaginationProps"
      @row-click="rowClickHandler">
    </stone-data-table>

  </div>
</template>

<script>

import common from '@/modules/common'

export default {
  name: 'M080104',
  mixins: [common.mixins],
  data () {
    return {
      tableProps: {height: this.getScreenHeight(-50)},
      tableData: [],
      tableTotal: 0,
      search: {
        search_text: '',
        title: ''
      },
      tableColumns: [
        {label: 'No', prop: 'rnum', align: 'left', width: 50, sortable: false},
        {label: '클래스명', prop: 'class_name', align: 'left', width: 80},
        {label: '시험명', prop: 'title', align: 'left', width: 200},
        {label: '유형', prop: 'exam_type_name', align: 'center', width: 60},
        {label: '과목', prop: 'subject', align: 'center', width: 70},
        // {label: '시험인원', prop: 'exam_user_cnt', align: 'right', formatter: this.columnFormatterNumber, width: 60},
        // {label: '응시인원', prop: 'exam_entry_cnt', align: 'right', formatter: this.columnFormatterNumber, width: 60},
        // {label: '응시율', prop: 'exam_entry_rate', align: 'right', formatter: this.columnFormatterRate, width: 70, dataType: 'percentage', format: '0.0%'},
        {label: '공개일자', prop: 'open_dt', align: 'center', formatter: this.columnFormatterDate, width: 80, dataType: 'date', format: 'yyyy.MM.dd'},
        // {label: '종료일자', prop: 'close_dt', align: 'center', formatter: this.columnFormatterDate, width: 80, dataType: 'date', format: 'yyyy.MM.dd'},
        {label: '상태', prop: 'stat_name', align: 'center', width: 50},
        {label: '구분', prop: 'exam_user_stat_name', align: 'center', width: 50},
        {label: '총 문제수', prop: 'quiz_cnt', align: 'right', formatter: this.columnFormatterNumber, width: 60},
        {label: '총 배점', prop: 'quiz_score', align: 'right', formatter: this.columnFormatterNumber, width: 60},
        {label: '평균 점수', prop: 'avg_score', align: 'right', formatter: this.columnFormatterNumber, width: 60},
        {label: '점수', prop: 'exam_user_score', align: 'right', formatter: this.columnFormatterNumberStat, width: 60},
        {label: '석차', prop: 'exam_user_rank', align: 'right', formatter: this.columnFormatterNumberStat, width: 60}
      ]
    }
  },
  created () {
    this.retrieve()
  },
  mounted () {
  },
  methods: {
    retrieve () {
      this.search.user_info_seq = this.$route.params.user_info_seq
      this.loadStoneDataTable('/exam/list/user/history', this.search)
        .then(response => {
          this.tableData = response.data
        })
        .catch(() => {
        })
    },
    rowClickHandler (row, event, column) {
      if (row.exam_user_stat !== 'S') {
        this.$message.warning('미응시한 수강생은 성적표를 확인할 수 없습니다.')
        return
      }
      const param = {
        exam_seq: row.exam_seq,
        class_seq: row.class_seq,
        class_user_seq: row.class_user_seq
      }
      this.$router.push({name: 'M060103', params: param})
    },
    downloadExcel () {
      const param = {
        data: {
          service: 'ExamService',
          method: 'selectExamUserHistory',
          params: this.search
        },
        excel: {
          columns: this.tableColumns,
          file: '시험이력'
        }
      }
      this.exportExcel(param)
    },
    onPopStateEventHandler () {
      if (this.$store.getters.page_params.query_info) {
        this.$route.params.query_info = this.$store.getters.page_params.query_info
      }
    },
    columnFormatterNumberStat (row, column) {
      return row.exam_user_stat === 'S' ? this.formatterNumber(row[column.property]) : '-'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/M080104.vue